import React, { memo, useCallback, useState } from 'react';
import Button from 'jd-library/Button';
import Loader from 'jd-library/Loader';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import styles from './Styles/upload-prompt.scss';
import toastMessageActions from 'jd-library/toastMessageActions';

const BulkExportPrompt = (props) => {
  const [showLoader, setLoader] = useState(() => false);
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    setLoader(() => true);
    // let params = {
    //   action: 'updateHeaderMapping',
    //   srcType: 'updateProductList'
    // }
    axios.get(`/vendorapis/reports/products/getproducts?source=dc&supplierId=${props.supplierId}`)
      .then(({ data }) => {
        setLoader(() => false);
        if(data.isSuccess){
          props.setCurrentStep();
        }else if(data.errors.code == 1) {
          dispatch(toastMessageActions.showMessage({
            message: 'No Products Found.',
            type: 'error'
          }))
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(() => false);
      })
  }, [])

  return (
    <>
      <div className={styles['upload-prompt']}>
        <div style={{ textAlign: 'center' }}>
          <img src='https://image1.jdomni.in/jdomni_email/undraw_upload_87y9_2004281701.png' />
          <div className={styles['prompt-heading']}>Export Product Details</div>
          <div className={styles['formats']}>File will be exported in .XLS format.
            This file will provide you the current product list in your account
          </div>
          <Button
            size='md'
            className={styles['upload-btn'] + (showLoader ? styles['with-loader'] : '')}
            clickHandler={handleClick}
            disabled={showLoader}
          >
            {showLoader ?
              (
                <div style={{ margin: 0 }}>
                  <Loader className={styles['upload-btn-loader']} /> Exporting
                </div>
              ) :
              'Export File'
            }
          </Button>
        </div>
      </div>
    </>
  )
}

export default memo(BulkExportPrompt);